(ns minorodata.notifications.subs
  (:require
   [re-frame.core :as re-frame]
   [minorodata.utils :refer [find-by-field]]
   [minorodata.app.utils :as app.utils]
   [re-posh.core :as re-posh]))


(re-posh/reg-query-sub
 :notifications.subs/job-notification-by-master-id
 '[:find [?notification-id ...]
   :in $ ?master-id
   :where [?notification-id :notification/source ?master-id]])


(re-posh/reg-sub
 :notifications.subs/job-notifications-raw
 (fn [[_ master-id]]
   (re-posh/subscribe [:notifications.subs/job-notification-by-master-id master-id]))
 (fn [notifications-eids]
   {:type    :pull-many
    :pattern '[*]
    :ids     notifications-eids}))


(re-frame/reg-sub
 :notifications.subs/job-notification
 (fn [[_ master-id]]
   (re-frame/subscribe [:notifications.subs/job-notifications-raw master-id]))
 (fn [notifications]
   (when (not-empty notifications)
     (let [slack    (find-by-field notifications :notification/target-type "slack")
           ms-teams (find-by-field notifications :notification/target-type "ms-teams")
           email    (find-by-field notifications :notification/target-type "email")]
       (app.utils/assoc-some {}
         :slack-webhook (and slack (:notification/target slack))
         :ms-teams-webhook (and ms-teams (:notification/target ms-teams))
         :email (and email (:notification/target email))
         :use-account-slack (and slack (:notification/use-account-slack slack))
         :use-account-ms-teams (and ms-teams (:notification/use-account-ms-teams ms-teams)))))))
